export default "<p>Ettore Cantagalli (1870-1916), artista, atleta e giornalista senese.</p>\n";